import React from 'react';

import NetworksIconsBar from '../../common/networks-icons-bar/networks-icons-bar';
import './home-main.css';

const HomeMain = () => {
  return (
    <div className='home-main'>
      <NetworksIconsBar />

      <div className='about'>
        <h3 className='page-title'>
          ABOUT ME
        </h3>

        <hr className='title-separator' />

        <div className='about-parts'>
          <div className='about-part'>
            <p>
              I have been coding for about 14 years now, eight of which have been as a full-stack web developer. During this time, I have grown passionate about JavaScript. Specifically, the Angular - Node stack is my favorite. I like to explore Angular in depth, I look forward to new releases, and I enjoy exploring any cutting-edge development.              
            </p>
            
            <p> 
              To share my excitement about new technologies, and opinions on popular topics, I began blogging. As a blogger, I love to share my knowledge in various ways. Currently, I manage the fast-growing community groups - 'Angular & Typescript' - on LinkedIn and Facebook. Now, I am starting this blog, as a place where I can gather all my publications and recommendations. 
            </p>
          </div>

          <div className='about-part'>
            <p>
              In this blog, you can find my articles, my open source projects, and recommendations to a lot of resources I found helpful for understanding many of topics in the web. Through this blog, I have also showcased my first lines of code in the awesome React framework. After 5 years of focusing on Angular all day long, I decided to dive into React. 
            </p>
            
            <p> 
              In the middle of 2017, I began to dedicate more time to learning React and exploring its intricacies. Recently, I visited ReactNext, which is Israel's international conference for React, where I had the opportunity to meet others with similar interests. I invite you to join my groups, to keep updated on the latest news and releases and be part of our ever-growing community of developers.              
            </p>
          </div>
        </div>
      </div> 
    </div>
  );
};

export default HomeMain;